import * as React from 'react'
import * as Api from 'src/api'
import { useApi } from 'src/helpers/hooks'
import { useAuthenticatedHeaders } from 'src/hooks/auth/app'
import { useTranslatable } from 'src/hooks/locale/utils'
import Loader from 'src/views/components/Loader'
import SuspenseWrapper from 'src/views/includes/SuspenseWrapper'
import { useStudentChoiceParams } from './constants'

/**
 * Reached only by opening the URL directly — the tab itself opens the printable page in a new browser tab
 * (see the layout). Here the current tab is sent to it instead.
 */
export default function AdministratorStudentChoicesPrintablePage(): JSX.Element {
  const t = useTranslatable()
  return (
    <SuspenseWrapper title={t('choice:printable_version')}>
      <PageContent />
    </SuspenseWrapper>
  )
}

function PageContent(): JSX.Element {
  const headers = useAuthenticatedHeaders()
  const { uid, profileId } = useStudentChoiceParams()

  const { data } = useApi({
    endpoint: Api.getAdministratorStudentChoiceHistory3PrintBySemester,
    params: React.useMemo(() => ({ headers, args: { uid, profileId } }), [headers, uid, profileId]),
  })

  React.useEffect(() => {
    location.replace(data.downloadUrl)
  }, [data.downloadUrl])

  return <Loader className="m-auto mt-8 flex" />
}
